<template>
  <b-row>
    <b-col lg="6" style="height: 500px;overflow: auto;">
      <h3>{{ $t("edu_courses.edu_courses") }}</h3>
      <hr />
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="course in courses"
          :key="course.id"
          button
          :active="course.id == courseSelected.id"
          @click="seleteCourse(course)"
        >
          <span>{{ course.name }}</span>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <b-col lg="6">
      <h3>{{ $t("exams.exams") }}</h3>
      <hr />
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="exam in exams"
          :key="exam.id"
          button
          @change="changeExam(exam)"
        >
          <b-form-radio
            v-model="examSelected"
            :value="exam.id"
            name="some-radio9"
            class="custom-control-primary"
          >
            {{ exam.name }}
          </b-form-radio>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <hr />

    <b-col lg="6">
      <b-button block variant="primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </b-button>
    </b-col>
    <b-col lg="6">
      <b-button block  @click="goToTable()" variant="success">
        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import EduProgramsController from "@/Controllers/EduProgramsController";
export default {
  data() {
    return {
      courses: [],
      exams: [],
      courseSelected: {},
      officialExams: [],
      examSelected: 0,
      data: [],
    };
  },
  created() {
    new EduProgramsController()
      .AssignOfficialExams(this.$route.params.eduProgramId)
      .then((res) => {
        this.courses = res.courses.filter((a) => a.flixable == 0);
      });
  },
  methods: {
    seleteCourse(course) {
      this.courseSelected = course;
      this.exams = course.exams;
      this.examSelected = course.pivot.official_exam_id;
    },
    changeExam(exam) {
      this.data.push({
        edu_program_id: this.$route.params.eduProgramId,
        edu_course_id: this.courseSelected.id,
        official_exam_id: exam.id,
      });
    },
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      new EduProgramsController().saveOfficialExams(
        this.$route.params.eduProgramId,
       { data:this.data}
      );
    },
  },
};
</script>

<style>
</style>